import { render, staticRenderFns } from "./DashboardV1.vue?vue&type=template&id=34ae830d&"
import script from "./DashboardV1.vue?vue&type=script&lang=js&"
export * from "./DashboardV1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "DashboardV1.vue"
export default component.exports